import {Language} from 'stores/AppStore';

/**
 * Get the browser language
 * @param {Language} defaultLanguage Default language
 * @return {Language} The current browser language
 */
export default function getBrowserLanguage(
    defaultLanguage: Language,
): Language {
  switch (navigator.language) {
    case 'ru-RU': return Language.Russian;
    case 'en-EN': return Language.English;
    default: return defaultLanguage;
  }
}
